import type { SvgIconProps } from "@mui/material"
import { SvgIcon } from "@mui/material"

export function Warning(props: SvgIconProps) {
  return (
    <SvgIcon width="16px" height="13px" viewBox="0 0 16 13" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.57756 0.999808L14.9282 11.9998C15.0473 12.2061 15.0473 12.4602 14.9282 12.6665C14.8091 12.8727 14.5891 12.9998 14.3509 12.9998H1.64956C1.41139 12.9998 1.19131 12.8727 1.07222 12.6665C0.953138 12.4602 0.95314 12.2061 1.07223 11.9998L7.42289 0.999808C7.54199 0.793557 7.76206 0.666504 8.00023 0.666504C8.23839 0.666504 8.45847 0.793557 8.57756 0.999808ZM2.80423 11.6665H13.1962L8.00023 2.66647L2.80423 11.6665ZM7.33356 9.66648H8.66689V10.9998H7.33356V9.66648ZM7.33356 4.99981H8.66689V8.33314H7.33356V4.99981Z"
        fill="#e53f3f"
      />
    </SvgIcon>
  )
}
